/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_CodepushInputs */

const en_svchip_codepush = /** @type {(inputs: Svchip_CodepushInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CodePush`)
};

const ar_svchip_codepush = /** @type {(inputs: Svchip_CodepushInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`نشر الكود`)
};

const bn_svchip_codepush = /** @type {(inputs: Svchip_CodepushInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CodePush`)
};

const de_svchip_codepush = /** @type {(inputs: Svchip_CodepushInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CodePush`)
};

const es_svchip_codepush = /** @type {(inputs: Svchip_CodepushInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CódigoPush`)
};

const fr_svchip_codepush = /** @type {(inputs: Svchip_CodepushInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CodePush`)
};

const pt_svchip_codepush = /** @type {(inputs: Svchip_CodepushInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CodePush`)
};

const zh_svchip_codepush = /** @type {(inputs: Svchip_CodepushInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`代码推送`)
};

const tr_svchip_codepush = /** @type {(inputs: Svchip_CodepushInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CodePush`)
};

const ru_svchip_codepush = /** @type {(inputs: Svchip_CodepushInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CodePush`)
};

const pl_svchip_codepush = /** @type {(inputs: Svchip_CodepushInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CodePush`)
};

/**
* | output |
* | --- |
* | "CodePush" |
*
* @param {Svchip_CodepushInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_codepush = /** @type {((inputs?: Svchip_CodepushInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_CodepushInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_codepush(inputs)
	if (locale === "bn") return bn_svchip_codepush(inputs)
	if (locale === "de") return de_svchip_codepush(inputs)
	if (locale === "es") return es_svchip_codepush(inputs)
	if (locale === "fr") return fr_svchip_codepush(inputs)
	if (locale === "pt") return pt_svchip_codepush(inputs)
	if (locale === "zh") return zh_svchip_codepush(inputs)
	if (locale === "tr") return tr_svchip_codepush(inputs)
	if (locale === "ru") return ru_svchip_codepush(inputs)
	if (locale === "pl") return pl_svchip_codepush(inputs)
	return en_svchip_codepush(inputs)
});